import React, { useRef, useEffect } from 'react';
import ReactSelect, {
  OptionTypeBase,
  Props as SelectProps,
} from 'react-select';

import { useField } from '@unform/core';

import { Container, LabelContainer } from './styles';

interface Props extends SelectProps<OptionTypeBase> {
  name: string;
  label?: string;
  optional?: boolean;
  defaultInputValue?: string;
}
const Select: React.FC<Props> = ({
  name,
  label = null,
  options,
  defaultValue,
  optional = false,
  ...rest
}) => {
  const selectRef = useRef(null);
  const { fieldName, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      path: undefined,
      getValue: (ref) => {
        if (rest.isMulti) {
          if (!ref.state.value || !(ref.state.value instanceof Array)) {
            return [];
          }
          return ref.state.value.map((option: OptionTypeBase) => option.value);
        }
        if (!ref.state.value) {
          return '';
        }
        return ref.state.value.value;
      },
      clearValue: (ref) => {
        ref.select.clearValue();
      },
    });
  }, [fieldName, registerField, rest.isMulti]);

  const customStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    option: (base: any, { data, isFocused, isSelected }: any) => {
      return {
        ...base,
        color: isSelected && data.color ? '#fff' : data.color,
        backgroundColor: isSelected
          ? data.color || '#dfdfdf'
          : isFocused
          ? '#eee'
          : '#fff',
        ':active': {
          color: data.color,
          backgroundColor: '#efefef',
        },
      };
    },
    singleValue: (base: any, { data }: any) => ({ ...base, color: data.color }),
    multiValue: (styles: any) => {
      return {
        ...styles,
        backgroundColor: 'rgba(255, 153, 184, 0.25)',
        height: '30px',
        alignItems: 'center',
      };
    },
    multiValueLabel: (styles: any) => ({
      ...styles,
    }),
    multiValueRemove: (styles: any) => ({
      ...styles,
      height: '30px',
      ':hover': {
        backgroundColor: '#ff99b8',
        color: 'black',
      },
    }),
  };

  return (
    <Container hasLabel={!!label}>
      {label && (
        <LabelContainer>
          {<label htmlFor={fieldName}>{label}</label>}{' '}
          {optional && <small>(Opcional)</small>}
        </LabelContainer>
      )}
      <ReactSelect
        noOptionsMessage={() => 'Não há opções'}
        defaultValue={
          options?.find((option) => option.value === defaultValue) ||
          defaultValue
        }
        ref={selectRef}
        classNamePrefix="react-select"
        options={options}
        menuPlacement="auto"
        menuPortalTarget={document.body}
        styles={customStyles}
        {...rest}
      />
      {error && <span>{error}</span>}
    </Container>
  );
};
export default Select;
